import { createCombineMapItem } from '../../../../../reducerRegistry';

import { createReduceObject as createListReduceObject } from '../../../../../common/reducers/list/reducer';

import userFlowFundsByAuthUserListSaga from './sagas/userFlowFundsByAuthUserListSaga';

export default [
  // Lists
  ...createCombineMapItem(
    'userFlowFundsByAuthUserList',
    createListReduceObject,
    [userFlowFundsByAuthUserListSaga]
  )
];



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/userFlowFunds/reducers/static/lists/reducersMap.js